import { AxiosResponse } from 'axios';
import WbHttpClient from '../../services/wbhttpclient';

export default class KrTagService extends WbHttpClient
{
  /**
   * Create kr tags from popup
   * @param params
   */
  public createKRTags(params = {}): Promise<AxiosResponse> {
    return this.post('tagGroup/saveTag', params);
  }

  /**
   * create/edit save tag group
   * @param params 
   * @returns 
   */
  public saveTagGroup(params = {}): Promise<AxiosResponse> {
    return this.post('tagGroup/saveTagGroup', params);
  }

  /**
   * get group data by id
   * @param params 
   * @returns 
   */
  public getTagGroup(params = {}): Promise<AxiosResponse> {
    return this.get('tagGroup/editTagGroup', params);
  }

  /*
   * get kr tags
   * @param params
   */
  public getKrTags(params = {}) : Promise<AxiosResponse> {
    return this.get('tagGroup/tagLists', params);
  }

  /**
   * delete Tag 
   * @param params 
   * @returns 
   */
  public deleteTag(params = {}): Promise<AxiosResponse> {
    return this.post('tagGroup/deleteTag', params);
  }

  /**
   * archive Tag 
   * @param params 
   * @returns 
   */

  public archiveKrTag(params = {}): Promise<AxiosResponse> {
    return this.post('tagGroup/archiveTag', params);
  }
  /**
   * delete Tag Group
   * @param params
   * @returns
   */
   public deleteTagGroup(params = {}): Promise<AxiosResponse> {
    return this.post('tagGroup/deleteTagGroup', params);
  }

  /**
   * archive Tag Group
   * @param params
   * @returns
   */

  public archiveKrTagGroup(params = {}): Promise<AxiosResponse> {
    return this.post('tagGroup/archiveTagGroup', params);
  }

/**
   * active Tag Group
   * @param params
   * @returns
   */

 public activeKrTagGroup(params = {}): Promise<AxiosResponse> {
  return this.post('tagGroup/activeTagGroup', params);
}

  public searchKrTags(params = {}) : Promise<AxiosResponse> {
    return this.get('tagGroup/searchKRTag', params);
  }

  /**
   * delete KR Tag
   * @param params 
   * @returns 
   */
  public deleteKRTag(params = {}) : Promise<AxiosResponse> {
    return this.post('tagGroup/deleteKRTag', params);
  }

  
  public browseTag(params = {}) : Promise<AxiosResponse> {
    return this.get('tagGroup/browseTag', params);
  } 

  public tagGroupCount(params = {}) : Promise<AxiosResponse> {
    return this.get('tagGroup/tagGroupCount', params);
  } 

  public tagDeleteKRCount(params = {}) : Promise<AxiosResponse> {
    return this.get('tagGroup/tagKRCount', params);
  }

  /**
   * Validate kr tags from create tag popup
   * @param params
   */
  public tagValidate(params = {}) : Promise<AxiosResponse> {
    return this.post('tagGroup/validateTag', params);
  } 

  /**
   * Disable Tag Tool Tip 
   * @param params
   */
   public disableTagToolTip(params = {}) : Promise<AxiosResponse> {
    return this.post('tag/saveTagToolTip', params);
  }
  /**
   * 
   * @param params Get tags,keywords
   * @param params
   */
  public findTags(params={}): Promise<AxiosResponse> {
    return this.get('tag/searchTagKeywordResults',params);
  }

  /**
   * 
   * @param params Get tags,keywords
   * @param params
   */
   public getTagsKrList(params={}): Promise<AxiosResponse> {
    return this.get('tag/searchTagKRResults',params);
  }
  public applyKrTags(params = {}) : Promise<AxiosResponse> {
    return this.post('tag/saveUndoTagKRResults', params);
  }
  public getNlplTags(params={}): Promise<AxiosResponse> {
    return this.get('tag/getNlpKrTagLists',params);
  }

  krTagEvents(params = {}): Promise<AxiosResponse> {
    return this.get('tag/krTagEvents', params)
  }

}